<template>
  <div>
    <!-- Slot para o conteúdo -->
    <div 
      @contextmenu.prevent="openContextMenu"
      @auxclick="handleAuxClick"
    >
      <slot></slot>
    </div>

    <!-- Menu contextual - Vuetify 1.5 -->
    <v-menu
      v-model="showMenu"
      :position-x="positionX"
      :position-y="positionY"
      absolute
      offset-y
    >
      <v-list dense>
        <template v-for="(item, index) in menuItems">
            <v-divider v-if="item.type === 'divider'"></v-divider>
            <v-list-tile
                v-if="item.type !== 'divider'"
                :key="index"
                @click="handleItemClick(item)"
            >
                <v-list-tile-action v-if="item.icon">
                    <v-icon :class="item.className ? item.className : ''">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title :class="item.className ? item.className : ''">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
        </template>
        
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'RightClickComponent',
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    currentItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showMenu: false,
      positionX: 0,
      positionY: 0
    }
  },
  methods: {
    openContextMenu(e) {
      e.preventDefault()
      this.showMenu = false
      this.positionX = e.clientX
      this.positionY = e.clientY
      
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    
    handleAuxClick(e) {
      if (e.button === 1) {
        e.preventDefault()
        e.stopPropagation()
        this.$emit('middle-click', this.currentItem, e)
      }
    },
    
    handleItemClick(item) {
      this.$emit('item-click', item, this.currentItem)
      this.showMenu = false
    }
  }
}
</script>